require("./style.scss");

import React from "react";
import ReactDOM from "react-dom";

import ContactList from "./ContactList";


ReactDOM.render(
    <ContactList />,
    document.getElementById("root")
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/